export type ReportType = `service_report_completed` | `service_report_canceled`;

export enum ReportTypeEnum {
  SERVICE_REPORT_COMPLETED = `service_report_completed`,
  SERVICE_REPORT_CANCELED = `service_report_canceled`,
}
